export const downloadBlobFile = (
  response: { data: Blob; headers: Record<string, string> },
  defaultFileName = "Points.xlsx"
) => {
  const blob = response.data;
  const disposition = response.headers["content-disposition"];
  const filenameMatch = disposition?.match(/filename="(.+?)"/);
  const filename = filenameMatch?.[1] ?? defaultFileName;

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
